import { action } from "mobx";
import TourVideoRequestRepository from "~/repository/Tour/TourVideoRequestRepository";
import NestStore from "../NestStore";

class TourVideoRequestStore extends NestStore {
  tourVideoRequestRepository = null;

  constructor() {
    super();

    this.tourVideoRequestRepository = new TourVideoRequestRepository();
  }

  @action
  create(tourId) {
    return this.tourVideoRequestRepository.create(tourId).catch(error => {
      this.errorMessage = error.message;
      throw error;
    });
  }
}

export default TourVideoRequestStore;
